var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41248 2.14609H1.89218V10.3601H5.41248V2.14609ZM6.58591 2.14609V10.3601H10.1062V2.14609H6.58591ZM1.30547 0.972656H10.6929C10.8485 0.972656 10.9978 1.03447 11.1078 1.1445C11.2178 1.25453 11.2796 1.40377 11.2796 1.55937V10.9468C11.2796 11.1024 11.2178 11.2517 11.1078 11.3617C10.9978 11.4717 10.8485 11.5335 10.6929 11.5335H1.30547C1.14986 11.5335 1.00063 11.4717 0.890595 11.3617C0.780565 11.2517 0.71875 11.1024 0.71875 10.9468V1.55937C0.71875 1.40377 0.780565 1.25453 0.890595 1.1445C1.00063 1.03447 1.14986 0.972656 1.30547 0.972656Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.670fb4ce4faa0cbefc12e1e4df58cf46.svg";
export { ForwardRef as ReactComponent };